export default class AuthorizationGroup {
    constructor(space = null, company = null, departments = [], teams = [], users = []) {
        this.space = space;
        this.company = company;
        this.departments = departments;
        this.teams = teams;
        this.users = users;
    }
}
